import * as React from "react";
import Modal from "@mui/material/Modal";
import { Box, MenuItem } from "@mui/material";
import { ReactComponent as StoreIcon } from "../../../../../assets/img/store.svg";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import NewConnectStoreModal from "./NewConnectStoreModal";
import { useDispatch, useSelector } from "react-redux";
import { authSelector, getLoggedUser } from "../../../../../redux/slices/authSlice";
import { getCurrentStore } from "../../../../../api/store";
import AddNewStoreModal from "./AddNewStoreModal";
import useDecodedToken from "../../../../../hooks/useDecodeToken";
import { storeSelector } from "../../../../../redux/slices/storeSlice";
import { isClientPreview } from "../../../../../utils/clientPreview";
import storesStyles from "./storesModal.module.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "600px",
  height: "570px",
  //   overflowY: "scroll",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  padding: "0 30px",
  borderRadius: "20px",
  p: "40px 30px",
};

const containerStyle = {
  marginTop: "50px",
  height: "350px",
  overflowY: "scroll",
  padding: "0 20px",
};

const logoStyle = {
  width: "45px",
  height: "45px",
  objectFit: "contain",
  marginRight: "20px",
};

const getPlaceholderLogoStyle = (index) => ({
  background: index % 2 === 0 ? "#f1b291" : "#8fb0b5",
  marginRight: "20px",
  width: "50px",
  height: "50px",
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const placeholderTextStyle = {
  color: "#fff",
};

const textContainerStyle = {
  textAlign: "left",
};

const titleStyle = {
  fontSize: "16px",
  margin: 0,
};

const subtitleStyle = {
  marginTop: "10px",
  fontWeight: 400,
  marginBottom: 0,
};

export default function NewStoreConnectWithStoreListModal({
  sidebarExpand,
  fromSidebar,
  storeOwner,
  dark,
  renderTrigger,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { loggedUser } = useSelector(authSelector);
  const { storeInfo, activeUserStores } = useSelector(storeSelector);
  const dispatch = useDispatch();
  const decodedData = useDecodedToken();

  const stores = loggedUser?.stores;

  const [hoveredIndex, setHoveredIndex] = React.useState(null);

  const handleCurrentStore = async (storeId) => {
    await dispatch(getCurrentStore({ storeId: storeId })).then(({payload}) => console.log("current store payload", payload)) ;
    window.location.reload();
  };

  const loggedUserActiveStores =
  activeUserStores?.store?.length > 0 &&
  activeUserStores?.store?.filter(
    (active) =>
      active?.users?.status === "active" &&
      active?.is_active &&
      active?.users?.user_id?._id.toString() ===
        loggedUser?.user?._id.toString()
  );

  const getActiveStore = () => {
    const activeStoreFromLocalStorage = localStorage.getItem("active_store");
    if (activeStoreFromLocalStorage) {
      const findStore =
        loggedUserActiveStores?.length > 0 &&
        loggedUserActiveStores?.find(
          (store) =>
            store._id.toString() === activeStoreFromLocalStorage.toString()
        );
      return findStore;
    }
  };

  const activeStore = getActiveStore();

  const findActiveStoreForLogo = loggedUser?.stores?.find(
    (store) => store?._id?.toString() === activeStore?._id?.toString()
  );

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  // Function to update window width
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    if (storeInfo?.active_store) {
      localStorage.setItem("active_store", storeInfo?.active_store);
      dispatch(getLoggedUser(storeInfo));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeInfo?.active_store]);

  const getItemStyle = (index) => ({
    display: "flex",
    alignItems: "flex-start",
    marginTop: "15px",
    cursor: "pointer",
    padding: "10px",
    borderRadius: "8px",
    transition: "background-color 0.3s ease",
    backgroundColor: hoveredIndex === index ? "#faf8f8" : "transparent",
  });

  return (
    <>
      <>
        {fromSidebar ? (
          <div
            onClick={handleOpen}
            style={{
              width: "100%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              borderRadius: dark ? "10px" : "5px",
              backgroundColor: dark ? "#242424" : sidebarExpand ? "#F3EAFE" : "transparent",
              boxShadow: dark ? "inset 0 0 0 1px #333" : undefined,
              justifyContent: dark ? "flex-start" : "center",
              padding: dark ? "0 10px" : undefined,
              cursor: "pointer",
              height: "50px",
              boxSizing: "border-box",
            }}
          >
            <img
              src={
                findActiveStoreForLogo?.store_logo ||
                "https://u-send.s3.eu-west-2.amazonaws.com/shopify-logo.png"
              }
              alt="logo"
              style={{
                maxWidth: windowWidth <= 1592 ? "25px" : "30px",
                height: "30px",
                // marginLeft: sidebarExpand ? "-25px" : "0",
                marginRight:
                  sidebarExpand && windowWidth > 1592 ? "10px" : "2px",
                objectFit: "contain",
              }}
            />
            {sidebarExpand && (
              <div style={{ color: dark ? "#e3e3e3" : "#5F5F5F", marginLeft: "5px", minWidth: 0 }}>
                <div
                  style={{
                    fontSize: windowWidth <= 1592 ? "12px" : "15px",
                    fontWeight: "700",
                  }}
                >
                  {findActiveStoreForLogo?.custom_store_name ||
                    decodedData?.customStoreName ||
                    "Workspace"}
                </div>
                <div style={{ fontSize: "10px", fontWeight: "500" }}>
                  {storeOwner
                    ? storeOwner?.shop_name
                    : decodedData?.storeName
                    ? decodedData?.storeName
                    : activeStore
                    ? activeStore?.store_name
                    : loggedUserActiveStores[0]?.store_name}
                </div>
              </div>
            )}
          </div>
        ) : renderTrigger ? (
          renderTrigger(handleOpen)
        ) : (
          <MenuItem
            sx={{
              fontSize: "14px",
              color: "#9d9d9d",
            }}
            onClick={() => {
              handleOpen();
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  justifySelf: "center",
                  marginRight: "5px",
                }}
              >
                {/* <MdOutlineStore size={16} style={{ color: "black" }} /> */}
                <StoreIcon width="16" height="16" />
              </div>{" "}
              <p style={{ fontWeight: 400 }}>Add stores</p>
            </div>
          </MenuItem>
        )}
      </>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        {isClientPreview() ? (
          <Box className={storesStyles.panel}>
            <header className={storesStyles.head}>
              <h2>Stores</h2>
              <button type="button" className={storesStyles.close} onClick={handleClose} aria-label="Close">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            </header>
            {stores?.length > 0 ? (
              <ul className={storesStyles.list}>
                {stores.map((store) => {
                  const current = String(store?._id) === String(loggedUser?.active_store);
                  const name = store?.custom_store_name || store?.store_name?.split(".")[0] || "Store";
                  return (
                    <li key={store?._id}>
                      <button
                        type="button"
                        className={`${storesStyles.store} ${current ? storesStyles.current : ""}`}
                        onClick={() => !current && handleCurrentStore(store?._id)}
                        aria-current={current ? "true" : undefined}
                      >
                        {store?.store_logo ? (
                          <img className={storesStyles.logo} src={store.store_logo} alt="" />
                        ) : (
                          <span className={`${storesStyles.logo} ${storesStyles.initial}`}>{name.slice(0, 1).toUpperCase()}</span>
                        )}
                        <span className={storesStyles.text}>
                          <b>{name}</b>
                          <span>{store?.store_name}</span>
                        </span>
                        <svg className={current ? storesStyles.check : storesStyles.chevron} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                          <path d={current ? "M5 12.5l4.5 4.5L19 7.5" : "M9 6l6 6-6 6"} />
                        </svg>
                      </button>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <p className={storesStyles.empty}>You have no store connected yet.</p>
            )}
            <footer className={storesStyles.foot}>
              <AddNewStoreModal closeModal={handleClose} label="Connect another store" />
            </footer>
          </Box>
        ) : (
        <Box sx={style}>
          <h4 style={{ fontSize: "28px" }}>
            Welcome, {loggedUser?.user?.first_name}
          </h4>
          <h6 style={{ marginTop: "15px", fontWeight: 400, fontSize: "16px" }}>
            Choose your store
          </h6>
          <div style={containerStyle}>
            {stores?.length > 0 ? (
              stores?.map((store, i) => (
                <div
                  key={store.id}
                  style={getItemStyle(i)}
                  onMouseEnter={() => setHoveredIndex(i)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => handleCurrentStore(store?._id)}
                >
                  {store?.store_logo ? (
                    <div>
                      <img
                        src={store?.store_logo}
                        alt="logo"
                        style={logoStyle}
                      />
                    </div>
                  ) : (
                    <div style={getPlaceholderLogoStyle(i)}>
                      <small style={placeholderTextStyle}>
                        {store?.custom_store_name?.split(" ")[0] || "N/A"}
                      </small>
                    </div>
                  )}
                  <div style={textContainerStyle}>
                    <h5 style={titleStyle}>
                      {store?.custom_store_name || "Not Available"}
                    </h5>
                    <h6 style={subtitleStyle}>{store?.store_name}</h6>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  justifyContent: "center",
                }}
              >
                <h4 style={{ color: "lightgray", fontWeight: 500 }}>
                  You have no store connected yet.
                </h4>
              </div>
            )}
          </div>

          <div
            style={{
              position: "absolute",
              bottom: 30,
              left: 0,
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {/* <NewConnectStoreModal title="newUI" /> */}
            <AddNewStoreModal closeModal={handleClose} />
          </div>
        </Box>
        )}
      </Modal>
    </>
  );
}
